import { KeyValue } from '@ibinder/ui-common-core';

import { COUNTRY_LIST, LANGUAGE_LIST } from '../../../../constants/common';
import { FormType } from './GeneralSettings.types';

export const statusRadio: KeyValue[] = [
  {
    Key: true,
    Value: 'Enabled'
  },
  {
    Key: false,
    Value: 'Disabled'
  }
];

export const omsTypeRadio: KeyValue[] = [
  {
    Key: 'Standard',
    Value: 'Standard'
  },
  {
    Key: 'Custom',
    Value: 'Custom integration'
  }
];

export const form: FormType = [
  {
    type: 'row',
    items: [
      {
        type: 'select',
        label: 'Country',
        id: 'country'
      },
      {
        type: 'select',
        label: 'Language',
        id: 'language'
      }
    ]
  },
  {
    type: 'text',
    label: 'Name',
    required: true,
    id: 'name'
  },
  {
    type: 'text',
    label: 'Address',
    required: true,
    id: 'address'
  },
  {
    type: 'text',
    label: 'Web',
    required: true,
    id: 'website'
  },
  {
    type: 'row',
    items: [
      {
        type: 'text',
        label: 'E-mail',
        required: true,
        id: 'email'
      },
      {
        type: 'text',
        label: 'Phone',
        id: 'phoneNumber'
      }
    ]
  }
];

export const selectData: Record<string, KeyValue[]> = {
  language: Object.keys(LANGUAGE_LIST).map((key) => ({
    Key: key,
    Value: LANGUAGE_LIST[key].name
  })),
  country: Object.keys(COUNTRY_LIST).map((key) => ({
    Key: key,
    Value: COUNTRY_LIST[key].name
  }))
};

export const defaultData = {};
